import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

@Component({
  selector: 'app-validade-cnh',
  templateUrl: './validade-cnh.component.html',
  styleUrls: ['./validade-cnh.component.css']
})
export class ValidadeCnhComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    public datepipe: DatePipe,
    private authenticationService: AuthenticationService,
    private relatorioService: RelatorioService
  ) { }

  private currentUser: Auth;
  public cnhs: any[];
  
  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    
    this.carregarRelatorio(1);
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.getCnhExpiration(this.currentUser.token.assignorGuid,(page-1),+this.showItem)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.cnhs = response.result.items;
        this.totalItems = response.result.totalItems;        
      }
    });
  }

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }
}
